import { computed } from 'vue';
import { rawDynamicImport } from '@app/helpers/memberships/section';
import { data } from '@app/booking/state/store'

export default function(validate, form){
    return {
        title     : 'Workshops',
        component : rawDynamicImport(() => import('@app/booking/components/form/stages/workshops/Workshops.vue')),
        visible   : computed(
            () => (form.value.ticket.ticket?.timeslot_ids ?? []).some(
                (timeslotId) => data.event.details.value.workshops.findIndex(
                    (workshop) => workshop.timeslot_ids.indexOf(timeslotId) !== -1 
                ) !== -1
            )
        ),
        isValid   : computed(
            () => (form.value.ticket.ticket?.timeslot_ids ?? []).every(
                (timeslotId) => {
                    const hasWorkshopsAvailable = data.event.details.value.workshops.findIndex(
                        (workshop) => workshop.timeslot_ids.indexOf(timeslotId) !== -1 
                    ) !== -1

                    if(!hasWorkshopsAvailable){
                        return true;
                    }

                    return form.value.workshops[timeslotId]?.id !== undefined
                }  
            )
        ),
        data: computed(
            () => ({
                workshops: Object.keys(form.value.workshops)
                    .reduce((workshops, timeslotId) => ({
                        ...workshops,
                        [timeslotId]: form.value.workshops[timeslotId]?.id
                    }), {})
            })
        ),
    }
}